import styled from 'styled-components';

export default styled.div`
  font-size: 1rem;
  font-weight: 500;
`;
